import React from 'react';
import { Box, Typography, Grid, Stack } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import Stagger from './Stagger';


export default function Footer() {
  return (
    <Box component="footer" sx={{ background: '#1d365a', color: '#fff', py: 6 }}>
      <Box maxWidth={1200} mx="auto" px={2}>
        <Stagger baseDelay={0} step={120} variants={['fade-up', 'slide-right']} distance={18}>
          <Grid container spacing={4} sx={{justifyContent: 'space-evenly'}}>
            <Grid item xs={12} md={4} sx={{ maxWidth: '400px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, letterSpacing: 1 }}>
                  Descubrí <span style={{ color: '#f0961f' }}>La Granja</span>
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.85)', fontSize: '14px', lineHeight: 1.5 }}>
                La Granja es un destino turístico ubicado en las Sierras Chicas de Córdoba, Argentina. Un lugar donde la naturaleza, la cultura y la gastronomía se combinan para ofrecerte experiencias inolvidables.
              </Typography>
             
            </Grid>
         {/*} <Grid item xs={12} md={4} sx={{ maxWidth: '200px' }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#fff', fontWeight: 700, fontSize: '18px' }}>Secciones</Typography>
            <Stack component="ul" spacing={1} sx={{ listStyle: 'none', pl: 0, mb: 2 }}>
              {navLinks.map(link => (
                <li key={link.label}>
                  <Link href={link.href} underline="none" sx={{ color: '#fff', fontWeight: 500, fontSize: '14px', '&:hover': { color: '#f0961f' } }}>{link.label}</Link>
                </li>
              ))}
            </Stack>
          </Grid>*/}
            <Grid item xs={12} md={4} sx={{ maxWidth: '300px' }}>
              <Typography variant="h6" sx={{ mb: 2, color: '#fff', fontWeight: 700, fontSize: '18px' }}>Contacto</Typography>
              <Stack spacing={1.5}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <a href="https://wa.me/5493525601475" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none'}}>
                  <WhatsAppIcon sx={{ color: '#25D366', fontSize: 20 }} />
                  <Typography 
                    variant="body2" 
                   
                    sx={{ 
                      color: 'rgba(255,255,255,0.85)', 
                      fontSize: '14px',
                      textDecoration: 'none',
                      '&:hover': {
                        color: '#25D366',
                      }
                    }}
                  >
                   {' '} +54 9 3525 601475
                  </Typography>
                  </a>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <a href="https://www.instagram.com/turismo.lagranja/" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none'}}>
                  <InstagramIcon sx={{ color: '#E4405F', fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px',   '&:hover': {
                        color: '#25D366',
                      } }}>
                    {' '}@turismo.lagranja
                  </Typography>
                  </a>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <a href="https://www.facebook.com/profile.php?id=61554349030835&locale=es_LA" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none'}}>
                  <FacebookIcon sx={{ color: '#1877F2', fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px',   '&:hover': {
                        color: '#25D366',
                      } }}>
                    {' '}Secretaría de Turismo, Cultura y Deporte
                  </Typography>
                  </a>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: 1 }}>
                  <EmailIcon sx={{ color: '#EA4335', fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px',   '&:hover': {
                        color: '#25D366',
                      } }}>
                  lagranjaturismo@gmail.com
                  </Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.15)', mt: 4, pt: 3, textAlign: 'center', color: 'rgba(255,255,255,0.7)' }}>
            <Typography variant="body2">
              © {new Date().getFullYear()} Descubrí La Granja. Todos los derechos reservados.
            </Typography>
          </Box>
        </Stagger>
      </Box>
    </Box>
  );
} 